import { RouteItem } from '@eastcoal/router/types/route'

import { TENDER_AUCTION_PURCHASE_LIST_PAGE_PATH } from './constants/path'

export const tenderAuctionPurchaseListRoute: RouteItem = {
  title: '招标',
  path: TENDER_AUCTION_PURCHASE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
